<template>
  <div id="app" style="--accentColor: '#9C6DFE'" class="text-n-800">
    <router-view></router-view>
    <teleport-target id="portal-target-root" class="z-50" />
    <tutorial />
    <l-dialog-wrapper />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onBeforeMount, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { TeleportTarget } from 'vue-safe-teleport'

import { LDialogWrapper } from '@last/core-ui/paprika'

import Tutorial from '@/components/Tutorial.vue'
import { useFormErrors } from '@/composables/useFormErrors.ts'
import { useLayoutStore } from '@/modules/layout/store/layout'
import { useTrackingStore } from '@/store/tracking.ts'

const trackingStore = useTrackingStore()
const { identify } = trackingStore

useFormErrors()

onBeforeMount(() => {
  useLayoutStore()
})

const { locale } = useI18n()
onMounted(() => {
  nextTick(identify)
  locale.value = window.navigator.language || locale.value || 'en'
})
</script>
